export default "__VITE_PUBLIC_ASSET__0f1a555b__"